import React from 'react';
import { Clock, Building, Calendar } from 'lucide-react';

interface ConstraintsInputProps {
  value: {
    urgent: boolean;
    historicArea: boolean;
    desiredDelay: number;
  };
  onChange: (constraints: {
    urgent: boolean;
    historicArea: boolean;
    desiredDelay: number;
  }) => void;
}

const defaultValue = {
  urgent: false,
  historicArea: false,
  desiredDelay: 6
};

export const ConstraintsInput: React.FC<ConstraintsInputProps> = ({ 
  value = defaultValue, 
  onChange 
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-4">
        <ConstraintCard
          icon={<Clock className="h-6 w-6" />}
          label="Travaux urgents"
          value={value.urgent}
          onChange={(urgent) => onChange({ ...value, urgent })}
        />
        <ConstraintCard
          icon={<Building className="h-6 w-6" />}
          label="Zone classée"
          value={value.historicArea}
          onChange={(historicArea) => onChange({ ...value, historicArea })}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-neutral-700 mb-2">
          Délai souhaité
        </label>
        <div className="flex items-center space-x-2">
          <input
            type="number"
            value={value.desiredDelay}
            onChange={(e) => onChange({ ...value, desiredDelay: parseInt(e.target.value) || 0 })}
            min="1"
            max="24"
            className="input w-32"
          />
          <span className="text-neutral-500">mois</span>
        </div>
      </div>
    </div>
  );
};

interface ConstraintCardProps {
  icon: React.ReactNode;
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
}

const ConstraintCard: React.FC<ConstraintCardProps> = ({
  icon,
  label,
  value,
  onChange
}) => (
  <button
    type="button"
    onClick={() => onChange(!value)}
    className={`
      card flex items-center p-4 transition-all
      ${value ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
    `}
  >
    <div className={`mr-3 ${value ? 'text-primary' : 'text-neutral-600'}`}>
      {icon}
    </div>
    <span className={`font-medium ${value ? 'text-primary' : 'text-neutral-700'}`}>
      {label}
    </span>
  </button>
);